import { render } from "./EditPayment.vue?vue&type=template&id=4662f0d1"
import script from "./EditPayment.vue?vue&type=script&lang=js"
export * from "./EditPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__